import React from 'react';

export const renderJsonWithChips = (text) => {
  if (!text) return null;
  if (typeof text !== 'string') {
    try {
      text = JSON.stringify(text, null, 2);
    } catch (e) {
      return null;
    }
  }
  const parts = text.split(/(\{\{.*?\}\})/g);
  return parts.map((part, index) => {
    if (part.startsWith('{{') && part.endsWith('}}')) {
      const content = part.slice(2, -2);
      return (
        <span key={index} className="tw-bg-blue-50 tw-text-blue-600 tw-px-1.5 tw-py-0.5 tw-rounded-md tw-border tw-border-blue-200 tw-text-xs tw-font-medium tw-mx-0.5">
          {content}
        </span>
      );
    }
    return part;
  });
};
